import {
  AuthField,
  AuthFoot,
  AuthGlassCard,
  AuthOr,
  MissionBrand,
  MissionPhotoStage,
  SocialButtons,
  StagingNote,
  useMissionAuth,
} from "@/components/mission-chrome";
import { useSkipLoginGate } from "@/components/auth-bypass-redirect";
import { Button } from "@/components/ui/button";
import { MISSION_HOME } from "@/lib/auth-callback";
import { Navigate } from "react-router-dom";

export function RegisterPage() {
  const { skip, health, loaded, productionHost } = useSkipLoginGate();
  const auth = useMissionAuth(health);
  const emailEnabled = auth.emailOk || auth.cookieDemo;

  if (skip) return <Navigate to={MISSION_HOME} replace />;
  if (!loaded && !productionHost) {
    return (
      <div
        className="mission-surface relative h-full overflow-auto bg-black"
        role="status"
        aria-busy="true"
        aria-label="Loading"
      />
    );
  }

  return (
    <div className="mission-surface relative h-full overflow-auto bg-black">
      <MissionPhotoStage veil="auth" />
      <AuthGlassCard>
        <MissionBrand className="mb-1" />
        <h1 className="mt-1.5 mb-0.5 text-[22px] font-semibold text-white">Create account</h1>
        <p className="mb-3 text-[13px] text-white/55">Start your Mission on pcbx.ai</p>

        <SocialButtons
          health={health}
          busy={auth.busy}
          githubSolid={false}
          onGithub={() => void auth.signInSocial("github")}
          onGoogle={() => void auth.signInSocial("google")}
        />

        <AuthOr />

        <form
          key={loaded ? health.auth_mode ?? "unknown" : "pending"}
          className="flex flex-col gap-2.5"
          onSubmit={auth.onEmailForm("sign-up")}
        >
          <AuthField
            id="name"
            label="Name"
            placeholder="Your name"
            autoComplete="name"
            disabled={!emailEnabled || auth.busy}
          />
          <AuthField
            id="email"
            label="Email"
            type="email"
            placeholder="you@pcbx.ai"
            autoComplete="email"
            disabled={!emailEnabled || auth.busy}
          />
          <AuthField
            id="password"
            label="Password"
            type="password"
            placeholder="Create a password"
            autoComplete="new-password"
            disabled={!emailEnabled || auth.busy}
          />
          <AuthField
            id="confirm"
            label="Confirm password"
            type="password"
            placeholder="Confirm password"
            autoComplete="new-password"
            disabled={!emailEnabled || auth.busy}
          />
          <Button
            type="submit"
            className="mt-0.5 h-10 w-full rounded-full text-[13px] font-semibold tracking-[0.06em] uppercase"
            disabled={!emailEnabled || auth.busy}
          >
            {auth.busy ? "Working…" : "Create account"}
          </Button>
        </form>

        {auth.error ? <p className="mt-2.5 text-[12px] text-falcon">{auth.error}</p> : null}

        <AuthFoot to="/login" prompt="Already have an account?" action="Sign in" />
        <StagingNote health={health} loaded={loaded} />
      </AuthGlassCard>
    </div>
  );
}
